<div>
    <p-steps [model]="menus" [readonly]="false" [(activeIndex)]="activeIndex" class="stepper no-label"></p-steps>
    <div class="card" *ngIf="activeIndex == 0">
        <div class="p-grid" *ngIf="channel && channel != soChannel.CUSTOMER_RETURNS">
            <div class="p-col-6">
                <h6>Ship From</h6>
                <p>{{ detailsObj?.warehouse?.name }}</p>
                <p>
                    {{ detailsObj?.warehouse?.address?.streetAddress1 ?? "" }}
                    {{ detailsObj?.warehouse?.address?.streetAddress1 && detailsObj?.warehouse?.address?.streetAddress1?.length > 0 && detailsObj?.warehouse?.address?.streetAddress2 && detailsObj?.warehouse?.address?.streetAddress2.length > 0 ? "," : "" }}
                    {{ detailsObj?.warehouse?.address?.streetAddress2 ?? "" }}
                </p>
                <p> {{ detailsObj?.warehouse?.address?.state?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.city?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.zipCode }} </p>
                <p>
                    {{ detailsObj?.warehouse?.phoneNo }}
                </p>
            </div>
            <div class="p-col-6">
                <h6>Ship To</h6>
                <!-- <p>{{ detailsObj?.account?.businessName }}</p> -->
                <p>{{ shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName : detailsObj?.account?.businessName }}</p>
                <p>
                    {{ shippingAddress?.address?.streetAddress1 ?? "" }}
                    {{ shippingAddress?.address?.streetAddress1 && shippingAddress?.address?.streetAddress1?.length > 0 && shippingAddress?.address?.streetAddress2 && shippingAddress?.address?.streetAddress2?.length > 0 ? "," : "" }}
                    {{ shippingAddress?.address?.streetAddress2 ?? "" }}
                </p>
                <p> {{ shippingAddress?.address?.state?.name }}&nbsp;{{ shippingAddress?.address?.city?.name }}&nbsp;{{ shippingAddress?.address?.zipCode }} </p>
                <p> {{ shippingAddressContact?.firstName }} {{ shippingAddressContact?.lastName ? " " : "" }} {{ shippingAddressContact?.lastName }} </p>
                <p>
                    {{ shippingAddressContact && shippingAddressContact?.contactPhones && shippingAddressContact?.contactPhones[0]?.phone && shippingAddressContact?.contactPhones[0]?.phone?.number ? shippingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                </p>
            </div>
        </div>
        <div class="p-grid" *ngIf="channel && channel == soChannel.CUSTOMER_RETURNS">
            <div class="p-col-6">
                <h6>Ship From</h6>
                <!-- <p>{{ detailsObj?.account?.businessName }}</p> -->
                <p>{{ shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName : detailsObj?.account?.businessName }}</p>
                <p>
                    {{ shippingAddress?.address?.streetAddress1 ?? "" }}
                    {{ shippingAddress?.address?.streetAddress1 && shippingAddress?.address?.streetAddress1?.length > 0 && shippingAddress?.address?.streetAddress2 && shippingAddress?.address?.streetAddress2?.length > 0 ? "," : "" }}
                    {{ shippingAddress?.address?.streetAddress2 ?? "" }}
                </p>
                <p> {{ shippingAddress?.address?.state?.name }}&nbsp;{{ shippingAddress?.address?.city?.name }}&nbsp;{{ shippingAddress?.address?.zipCode }} </p>
                <p> {{ shippingAddressContact?.firstName }} {{ shippingAddressContact?.lastName ? " " : "" }} {{ shippingAddressContact?.lastName }} </p>
                <p>
                    {{ shippingAddressContact && shippingAddressContact?.contactPhones && shippingAddressContact?.contactPhones[0]?.phone && shippingAddressContact?.contactPhones[0]?.phone?.number ? shippingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                </p>
            </div>
            <div class="p-col-6">
                <h6>Ship To</h6>
                <p>{{ detailsObj?.warehouse?.name }}</p>
                <p>
                    {{ detailsObj?.warehouse?.address?.streetAddress1 ?? "" }}
                    {{ detailsObj?.warehouse?.address?.streetAddress1 && detailsObj?.warehouse?.address?.streetAddress1?.length > 0 && detailsObj?.warehouse?.address?.streetAddress2 && detailsObj?.warehouse?.address?.streetAddress2.length > 0 ? "," : "" }}
                    {{ detailsObj?.warehouse?.address?.streetAddress2 ?? "" }}
                </p>
                <p> {{ detailsObj?.warehouse?.address?.state?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.city?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.zipCode }} </p>
                <p>
                    {{ detailsObj?.warehouse?.phoneNo }}
                </p>
            </div>
        </div>
    </div>
    <div *ngIf="activeIndex == 1">
        <form [formGroup]="form">
            <ng-container formArrayName="packages">
                <ng-container *ngFor="let package of packages.controls; let i = index">
                    <div [formGroup]="getFormGroupAt(i)">
                        <p-panel header="Package {{ i + 1 }}" [toggleable]="true">
                            <ng-template pTemplate="icons">
                                <button pButton class="p-panel-header-icon p-link" (click)="removePackage(i)">
                                    <span class="pi pi-trash"></span>
                                </button>
                            </ng-template>
                            <div class="p-grid">
                                <div class="p-col-4">
                                    <label>Service Type <span style="color: red">*</span></label>
                                    <p-dropdown 
                                        [options]="serviceTypes" 
                                        formControlName="serviceType"
                                        placeholder="Select a service"
                                        [group]="true"
                                        (onChange)="changeService($event)"
                                        class="no-group-padding">
                                            <ng-template let-group pTemplate="group">
                                                <div class="flex align-items-center">
                                                    <span>{{ group.label }}</span>
                                                </div>
                                            </ng-template>
                                    </p-dropdown>
                                </div>
                                <div class="p-col-4">
                                    <label>Package Type <span style="color: red">*</span></label>
                                    <liono-treeSelect class="border-bottom-input" [options]="packageType" appendTo="body" formControlName="packageType" selectionMode="single" placeholder="Select Package Type" (onNodeSelect)="onPackageTypeChage(i)"> </liono-treeSelect>
                                </div>
                                <div class="p-col-4">
                                    <label>Ship Date <span style="color: red">*</span></label>
                                    <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100" [minDate]="minimumDate" formControlName="shipDate" (onSelect)="onShipDateSelect(i)"></p-calendar>
                                </div>
                            </div>
                            <div class="p-grid">
                                <div class="p-col-4">
                                    <label>Total Identical Packages</label>
                                    <p-dropdown [options]="packageOptions" appendTo="body" optionLabel="label" dataKey="id" formControlName="totalPackage"></p-dropdown>
                                </div>
                                <div class="p-col-4">
                                    <label>Weight (Pound) <span style="color: red">*</span></label>
                                    <input pInputText type="text" formControlName="weight" (keypress)="isNumberKey($event)" />
                                </div>
                                <div class="p-col-4">
                                    <label>Dimensions(in) <span style="color: red">*</span></label>
                                    <div class="p-d-flex">
                                        <input pInputText type="text" formControlName="length" (keypress)="isNumberKey($event)" placeholder="L" />
                                        <input pInputText type="text" formControlName="width" (keypress)="isNumberKey($event)" placeholder="W" />
                                        <input pInputText type="text" formControlName="height" (keypress)="isNumberKey($event)" placeholder="H" />
                                    </div>
                                </div>
                            </div>
                            <div class="p-grid">
                                <div class="p-col-4">
                                    <label>Declared Value
                                        <span class="pi pi-exclamation-circle" pTooltip="FedEx Covers up to $100 at no charge." tooltipPosition="top"></span>
                                    </label>
                                    <div class="p-d-flex">
                                        <input pInputText type="text" formControlName="packageValue" (keypress)="isNumberKey($event)" />
                                        <div class="p-ml-2">US. Dollars</div>
                                    </div>
                                </div>
                                <div class="p-col-4">
                                    <label>Reference #1</label>
                                    <input pInputText type="text" formControlName="reference1" />
                                </div>
                                <div class="p-col-4">
                                    <label>Reference #2</label>
                                    <input pInputText type="text" formControlName="reference2" />
                                </div>
                            </div>
                            <div class="p-grid">
                                <div class="p-col-4">
                                    <label>Pickup/Drop-off</label>
                                    <p-dropdown [options]="pickupTypeList" appendTo="body" optionLabel="name" dataKey="id" formControlName="pickupType" placeholder="Select Pickup/Drop-off"> </p-dropdown>
                                </div>
                                <div class="p-col-4" *ngIf="getFormGroupAt(i)?.controls?.cod?.value">
                                    <label>C.O.D Amount</label>
                                    <input pInputText type="text" formControlName="codAmount" />
                                </div>
                                <div class="p-col-4" *ngIf="getFormGroupAt(i)?.controls?.cod?.value">
                                    <label>C.O.D Method</label>
                                    <p-dropdown [options]="paymentMethod" appendTo="body" optionLabel="name" dataKey="id" formControlName="codMethod" placeholder="Select Method"> </p-dropdown>
                                </div>
                            </div>
                            <div class="p-grid">
                                <div class="p-col-4">
                                    <label>Special Services</label>
                                    <ng-container *ngIf="selectedServiceType?.group == 1 || selectedServiceType?.group == 3">
                                        <!-- <div class="p-field-checkbox p-mb-1" *ngIf="selectedServiceType?.group == 1">
                                            <p-checkbox [binary]="true" inputId="binary"></p-checkbox>
                                            <label for="binary">Non-standard packaging</label>
                                        </div> -->
                                        <ng-container *ngIf="selectedServiceType?.group == 3">
                                            <div class="p-field-checkbox p-mb-1">
                                                <p-checkbox [binary]="true" inputId="binary"></p-checkbox>
                                                <label for="binary">Inside pickup</label>
                                            </div>
                                            <div class="p-field-checkbox p-mb-1">
                                                <p-checkbox [binary]="true" inputId="binary"></p-checkbox>
                                                <label for="binary">Inside delivery</label>
                                            </div>
                                        </ng-container>
                                        <div class="p-field-checkbox p-mb-0">
                                            <p-checkbox [binary]="true" inputId="binary" [(ngModel)]="dryIceChecked" [ngModelOptions]="{standalone: true}"></p-checkbox>
                                            <label for="binary">Dry ice</label>
                                            <span class="pi pi-plus p-ml-2" style="font-size: 10px;" *ngIf="!dryIceChecked"></span>
                                            <span class="pi pi-minus p-ml-2" style="font-size: 10px;" *ngIf="dryIceChecked"></span>
                                        </div>
                                        <div *ngIf="dryIceChecked" class="p-ml-3 p-mb-1">
                                            *Total dry ice weight 
                                            <p-inputNumber mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" inputId="withoutgrouping" [useGrouping]="false" class="small inline" formControlName="dryIceWeight">
                                            </p-inputNumber>
                                            lbs.
                                        </div>
                                        <div class="p-field-checkbox p-mb-1">
                                            <p-checkbox [binary]="true" inputId="binary"></p-checkbox>
                                            <label for="binary">Dangerous goods</label>
                                        </div>
                                        <div class="p-field-checkbox p-mb-0" *ngIf="isVisibleBatteryField">
                                            <p-checkbox [binary]="true" inputId="binary" [(ngModel)]="batteryChecked" [ngModelOptions]="{standalone: true}"></p-checkbox>
                                            <label for="binary">Lithium Batteries/Cells</label>
                                            <span class="pi pi-plus p-ml-2" style="font-size: 10px;" *ngIf="!batteryChecked"></span>
                                            <span class="pi pi-minus p-ml-2" style="font-size: 10px;" *ngIf="batteryChecked"></span>
                                        </div>
                                        <div *ngIf="batteryChecked && isVisibleBatteryField" class="p-ml-3 p-mb-1">
                                            <span class="pi pi-exclamation-circle p-mr-2"></span>Alert:
                                            <div class="p-mb-2">This selection is only for identifying UN3481/UN3091 Section II Lithium Batteries and Cells.</div>
                                            <p-multiSelect [options]="batteries" formControlName="batteryType" defaultLabel="Select" 
                                            optionLabel="name" selectedItemsLabel="{0} items selected" appendTo="body" class="custom-width"></p-multiSelect>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="selectedServiceType?.group == 2">
                                        <div class="p-field-checkbox p-mb-1">
                                            <p-checkbox [binary]="true" inputId="binary"></p-checkbox>
                                            <label for="binary">Non-standard packaging</label>
                                        </div>
                                        <div class="p-field-checkbox p-mb-1">
                                            <p-checkbox [binary]="true" inputId="binary"></p-checkbox>
                                            <label for="binary">Limited Quantity</label>
                                        </div>
                                        <div class="p-field-checkbox p-mb-1">
                                            <p-checkbox [binary]="true" inputId="binary"></p-checkbox>
                                            <label for="binary">Small quantity exception</label>
                                        </div>
                                        <div class="p-field-checkbox p-mb-1">
                                            <p-checkbox [binary]="true" inputId="binary"></p-checkbox>
                                            <label for="binary">Dry ice</label>
                                        </div>
                                        <div class="p-field-checkbox p-mb-1">
                                            <p-checkbox [binary]="true" inputId="binary"></p-checkbox>
                                            <label for="binary">Battery</label>
                                        </div>
                                    </ng-container>
                                    <div class="p-field-checkbox p-mb-0" *ngIf="saturdayDeliveryAvailable">
                                        <p-checkbox [binary]="true" inputId="binary" [(ngModel)]="isSaturdayDeliveryChecked" [ngModelOptions]="{standalone: true}"></p-checkbox>
                                        <label for="binary">Saturday Delivery</label>
                                    </div>
                                </div>
                                <div class="p-col-4" *ngIf="selectedServiceType?.group == 1 || selectedServiceType?.group == 2">
                                    <label>Signature Type</label>
                                    <p-dropdown [options]="signatureTypes" appendTo="body" [showClear]="true" optionLabel="displayText" dataKey="code" placeholder="Select Method" formControlName="signatureType"></p-dropdown>
                                </div>
                            </div>
                        </p-panel>
                    </div>
                </ng-container>
            </ng-container>
        </form>
        <div class="p-text-right p-py-3">
            <p-button icon="pi pi-plus" (click)="addPackage()" [disabled]="!form.valid"></p-button>
        </div>
    </div>
    <div class="card" *ngIf="activeIndex == 2">
        <p-table [value]="shipmentRates?.output?.rateReplyDetails" responsiveLayout="scroll" selectionMode="single" [(selection)]="selectedService" dataKey="serviceName">
            <ng-template pTemplate="caption">
                <div>Available Shipping Service Option</div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>Service and Transit Time</th>
                    <th>Rate</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-product>
                <tr [pSelectableRow]="product">
                    <td>{{ product.serviceName }}</td>
                    <td>
                        {{ product.ratedShipmentDetails[0].totalNetFedExCharge | customNumberFormat: fractionDigits}}
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                    <td></td>
                    <td class="p-text-center" style="display: block">
                        {{ ratesText }}
                    </td>
                    <td></td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <ng-container *ngIf="activeIndex == 3">
        <div class="header">
            <h5>Shipping Address</h5>
        </div>
        <div class="card">
            <div class="p-grid" *ngIf="channel && channel != soChannel.CUSTOMER_RETURNS">
                <div class="p-col-6">
                    <h6>Ship From</h6>
                    <p>{{ detailsObj?.warehouse?.name }}</p>
                    <p>
                        {{ detailsObj?.warehouse?.address?.streetAddress1 ?? "" }}
                        {{ detailsObj?.warehouse?.address?.streetAddress1 && detailsObj?.warehouse?.address?.streetAddress1?.length > 0 && detailsObj?.warehouse?.address?.streetAddress2 && detailsObj?.warehouse?.address?.streetAddress2.length > 0 ? "," : "" }}
                        {{ detailsObj?.warehouse?.address?.streetAddress2 ?? "" }}
                    </p>
                    <p> {{ detailsObj?.warehouse?.address?.state?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.city?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.zipCode }} </p>
                    <p>
                        {{ detailsObj?.warehouse?.phoneNo }}
                    </p>
                </div>
                <div class="p-col-6">
                    <h6>Ship To</h6>
                    <!-- <p>{{ detailsObj?.account?.businessName }}</p> -->
                    <p>{{ shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName : detailsObj?.account?.businessName }}</p>
                    <p>
                        {{ shippingAddress?.address?.streetAddress1 ?? "" }}
                        {{ shippingAddress?.address?.streetAddress1 && shippingAddress?.address?.streetAddress1?.length > 0 && shippingAddress?.address?.streetAddress2 && shippingAddress?.address?.streetAddress2?.length > 0 ? "," : "" }}
                        {{ shippingAddress?.address?.streetAddress2 ?? "" }}
                    </p>
                    <p> {{ shippingAddress?.address?.state?.name }}&nbsp;{{ shippingAddress?.address?.city?.name }}&nbsp;{{ shippingAddress?.address?.zipCode }} </p>
                    <p> {{ shippingAddressContact?.firstName }} {{ shippingAddressContact?.lastName ? " " : "" }} {{ shippingAddressContact?.lastName }} </p>
                    <p>
                        {{ shippingAddressContact && shippingAddressContact?.contactPhones && shippingAddressContact?.contactPhones[0]?.phone && shippingAddressContact?.contactPhones[0]?.phone?.number ? shippingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                    </p>
                </div>
            </div>
            <div class="p-grid" *ngIf="channel && channel == soChannel.CUSTOMER_RETURNS">
                <div class="p-col-6">
                    <h6>Ship From</h6>
                    <!-- <p>{{ detailsObj?.account?.businessName }}</p> -->
                    <p>{{ shippingAddress?.address?.addressName && shippingAddress?.address?.addressName?.length > 0 ? shippingAddress?.address?.addressName : detailsObj?.account?.businessName }}</p>
                    <p>
                        {{ shippingAddress?.address?.streetAddress1 ?? "" }}
                        {{ shippingAddress?.address?.streetAddress1 && shippingAddress?.address?.streetAddress1?.length > 0 && shippingAddress?.address?.streetAddress2 && shippingAddress?.address?.streetAddress2?.length > 0 ? "," : "" }}
                        {{ shippingAddress?.address?.streetAddress2 ?? "" }}
                    </p>
                    <p> {{ shippingAddress?.address?.state?.name }}&nbsp;{{ shippingAddress?.address?.city?.name }}&nbsp;{{ shippingAddress?.address?.zipCode }} </p>
                    <p> {{ shippingAddressContact?.firstName }} {{ shippingAddressContact?.lastName ? " " : "" }} {{ shippingAddressContact?.lastName }} </p>
                    <p>
                        {{ shippingAddressContact && shippingAddressContact?.contactPhones && shippingAddressContact?.contactPhones[0]?.phone && shippingAddressContact?.contactPhones[0]?.phone?.number ? shippingAddressContact?.contactPhones[0]?.phone?.number : "" }}
                    </p>
                </div>
                <div class="p-col-6">
                    <h6>Ship To</h6>
                    <p>{{ detailsObj?.warehouse?.name }}</p>
                    <p>
                        {{ detailsObj?.warehouse?.address?.streetAddress1 ?? "" }}
                        {{ detailsObj?.warehouse?.address?.streetAddress1 && detailsObj?.warehouse?.address?.streetAddress1?.length > 0 && detailsObj?.warehouse?.address?.streetAddress2 && detailsObj?.warehouse?.address?.streetAddress2.length > 0 ? "," : "" }}
                        {{ detailsObj?.warehouse?.address?.streetAddress2 ?? "" }}
                    </p>
                    <p> {{ detailsObj?.warehouse?.address?.state?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.city?.name }}&nbsp;{{ detailsObj?.warehouse?.address?.zipCode }} </p>
                    <p>
                        {{ detailsObj?.warehouse?.phoneNo }}
                    </p>
                </div>
            </div>
        </div>
        <div class="header">
            <h5>Package Details</h5>
        </div>
        <div class="card" *ngFor="let package of form.value.packages; let i = index">
            <div class="p-grid">
                <div class="p-col-3">
                    <p> <b>Package Type: </b>{{ package?.packageType?.data?.name }} </p>
                    <p> <b>Total identical packages: </b>{{ package?.totalPackage?.value }} </p>
                    <p>
                        <b>Weight: </b>{{ package?.weight }}
                        {{ package?.mass?.name }}
                    </p>
                </div>
                <div class="p-col-3">
                    <p><b>Length: </b>{{ package?.length }} in</p>
                    <p><b>Width: </b>{{ package?.width }} in</p>
                    <p><b>Height: </b>{{ package?.height }} in</p>
                </div>
                <div class="p-col-3">
                    <p> <b>Declared Value: </b>{{ package?.packageValue }} </p>
                    <p><b>Reference #1: </b>{{ package?.reference1 }}</p>
                    <p><b>Reference #2: </b>{{ package?.reference2 }}</p>
                </div>
                <div class="p-col-3">
                    <p *ngIf="dryIceChecked">
                        <b>Dry ice:</b>
                        {{ package?.dryIceWeight }} lbs.
                    </p>
                    <p>
                        <b>Include lithium batteries:</b>
                        {{ batteryChecked && isVisibleBatteryField ? "Yes" : "No" }}
                    </p>
                    <p> <b>Signature Options : </b>{{ package?.signatureType?.code != '' ?  package?.signatureType?.code : "" }} </p>
                    <!-- <p *ngIf="!isVisibleCodField">
                        <b>C.O.D Amount ($) : </b>{{ codAmount | number: "1.2-2" }}
                        <span class="p-ml-4 pointer" (click)="showCodField()" *ngIf="getFormGroupAt(i)?.controls?.cod?.value">
                            <i class="pi pi-pencil"></i>
                        </span>
                    </p> -->
                    <!-- <p *ngIf="isVisibleCodField">
                        <b>C.O.D Amount ($) : </b>
                        <p-inputNumber [(ngModel)]="codAmount" [ngModelOptions]="{ standalone: true }" mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" [style]="{ width: '40%' }" (onBlur)="hideCodField()"> </p-inputNumber>
                    </p> -->
                </div>
            </div>
        </div>
        <div class="header">
            <h5>Shipping Service</h5>
        </div>
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <p><b>Name: </b>{{ selectedService?.serviceName }}</p>
                    <!-- <p>
                        <b>Shipping Cost: </b>{{
                        selectedService?.ratedShipmentDetails[0]
                        ?.totalNetFedExCharge
                        }}
                    </p> -->
                    <p *ngIf="!isVisibleShipCostField"
                        ><b>Shipping Cost: </b>{{ shippingCost | customNumberFormat: fractionDigits | currencySymbol }}
                        <span class="p-ml-4 pointer" (click)="showShippingCostField()">
                            <i class="pi pi-pencil"></i>
                        </span>
                    </p>
                    <p *ngIf="isVisibleShipCostField"
                        ><b>Shipping Cost: </b>
                        <p-inputNumber [(ngModel)]="shippingCost" [ngModelOptions]="{ standalone: true }" mode="decimal" [minFractionDigits]="fractionDigits" [maxFractionDigits]="fractionDigits" [style]="{ width: '10%' }" (onBlur)="hideShippingCostField()"> </p-inputNumber>
                    </p>
                    <div class="p-field-checkbox" *ngIf="channel && channel != soChannel.CUSTOMER_RETURNS">
                        <p-checkbox [(ngModel)]="isFreeShipping" [ngModelOptions]="{ standalone: true }" inputId="freeShipping" [binary]="true"></p-checkbox>
                        <div for="freeShipping" class="p-ml-2"> <b>Free Shipping</b><br /> </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <!-- <ng-template pTemplate="footer"> -->
    <div class="p-text-right p-pt-3" style="border-top: 1px solid #ddd">
        <ng-container *ngIf="activeIndex == 0">
            <button type="button" pButton (click)="onDialogClose()" label="Cancel" class="p-button-secondary p-mr-2"></button>
            <button type="button" pButton label="Next" (click)="nextStep(activeIndex)"></button>
        </ng-container>
        <ng-container *ngIf="activeIndex == 1">
            <button type="button" pButton (click)="backStep(activeIndex)" label="Back" class="p-button-secondary p-mr-2"></button>
            <button type="button" pButton label="Next" [disabled]="!form.valid" (click)="nextStep(activeIndex)"></button>
        </ng-container>
        <ng-container *ngIf="activeIndex == 2">
            <button type="button" pButton (click)="backStep(activeIndex)" label="Back" class="p-button-secondary p-mr-2"></button>
            <button type="button" pButton label="Next" [disabled]="!selectedService" (click)="nextStep(activeIndex)"></button>
        </ng-container>
        <ng-container *ngIf="activeIndex == 3">
            <button type="button" pButton (click)="backStep(activeIndex)" label="Back" class="p-button-secondary p-mr-2"></button>
            <button type="button" pButton label="Create Label" (click)="createLabel()" [disabled]="createLabelSubmitted"></button>
        </ng-container>
    </div>
</div>
